module.exports = __webpack_public_path__ + "static/media/group-nodata.15dd69ac.png";